/* eslint no-console: 0, camelcase: 0 */
import isMobile from 'ismobilejs'

function timeStamp() {
  return parseInt(Date.now() / 1000, 10);
}

export default class IntercomRestClient {
  constructor({appId, apiToken, apiUrl}) {
    this._appId = appId;
    this._apiToken = apiToken;
    this._apiUrl = apiUrl;
    this._userId = null;
    this._ajaxQueue = [];
    this._processing = false;
  }

  processQueue(queue) {
    console.log('Processing Intercom queue backlog.', queue);
    const self = this;
    queue.forEach(item => {
      const action = item[0];
      const args = Array.prototype.slice.call(item, 1);
      const fn = self[action];
      if (fn) {
        fn.apply(self, args);
      }
    });
  }

  boot(data) {
    const {app_id, name, email, user_id, ...restOfData} = data;
    this._userId = data.user_id;
    if (!this._userId) return false;
    const intercomData = {
      name,
      email,
      user_id,
      update_last_request_at: true,
      custom_attributes: restOfData
    };
    this._enqueueAjax('POST', 'users', intercomData);
    return true;
  }

  update(data) {
    const {name, email, userId, ...restOfData} = data;
    if (!this._userId && !userId) return false;
    const intercomData = {
      name,
      email,
      user_id: userId || this._userId,
      update_last_request_at: true,
      custom_attributes: restOfData
    };
    this._enqueueAjax('POST', 'users', intercomData);
    return true;
  }

  trackEvent(eventName, metadata) {
    const {phone, tablet} = isMobile;
    const deviceInfo = {};
    if (phone) {
      deviceInfo.phone = true;
    } else if (tablet) {
      deviceInfo.tablet = true;
    } else {
      deviceInfo.desktop = true;
    }
    const {userId, id} = metadata;
    if (!userId && id) {
      const intercomData = {
        event_name: eventName,
        created_at: timeStamp(),
        id,
        metadata: {...metadata, deviceInfo}
      };
      this._enqueueAjax('POST', 'events', intercomData);
      return true;
    }
    if (!this._userId && !userId) return false;
    const intercomData = {
      event_name: eventName,
      created_at: timeStamp(),
      user_id: userId || this._userId,
      metadata: {...metadata, deviceInfo}
    };
    this._enqueueAjax('POST', 'events', intercomData);
    return true;
  }

  shutdown() {
    return false;
  }

  hide() {
    return false;
  }

  show() {
    return false;
  }

  showNewMessage() {
    return false;
  }

  _logErrorIfAny(err) {
    if (err) {
      console.log(err.message, err.stack);
    }
  }

  _ajax(method, intercomEndpoint, data, cb) {
    this._processing = true;
    const xhr = new XMLHttpRequest();
    xhr.open(method, this._apiUrl + intercomEndpoint, true);
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader('Authorization', 'Bearer ' + this._apiToken);
    xhr.addEventListener('readystatechange', () => {
      if (xhr.readyState !== XMLHttpRequest.DONE) return;
      this._processing = false;
      if (xhr.status >= 400) {
        const error = new Error(['Request failed:', method, intercomEndpoint, 'returned', xhr.status, xhr.statusText].join(' '));
        error.response = xhr.response;
        error.responseType = xhr.responseType;
        cb(error);
        return;
      }
      cb(null, xhr.response);
    });
    xhr.send(data ? JSON.stringify(data) : null);
  }

  _enqueueAjax(method, intercomEndpoint, data, cb) {
    this._ajaxQueue.push([method, intercomEndpoint, data, cb]);
    this._tryProcessQueue();
  }

  _tryProcessQueue() {
    if (this._processing) return;

    let args = this._ajaxQueue.shift();
    if (!args) return;
    const cb = args[3];

    this._ajax(args[0], args[1], args[2], (err, res) => {
      this._logErrorIfAny(err);
      setTimeout(this._tryProcessQueue.bind(this), 0);
      if (cb) cb(err, res);
    });
  }

  createLead(data) {
    return new Promise((resolve, reject) => {
      this._enqueueAjax('POST', 'contacts', data, (err, res) => {
        if (err) return reject(err);
        if (typeof res === 'string') {
          try {
            res = JSON.parse(res);
          } catch (e) {
            reject(err);
          }
        }
        resolve(res.id);
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/intercomRestClient.js